import * as tslib_1 from "tslib";
import { ContentContainer } from './content_container';
var TabPage = /** @class */ (function (_super) {
    tslib_1.__extends(TabPage, _super);
    function TabPage(param) {
        return _super.call(this, param) || this;
    }
    TabPage.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "TabPage" });
    };
    TabPage.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return TabPage;
}(ContentContainer));
export { TabPage };
//# sourceMappingURL=tab_page.js.map